import SidebarContainer from './SidebarContainer';

export default SidebarContainer;
